const { formatDateForApi } = require('@/lib/Dates/dateFunctions');
const { toDate, toFloat, toNullableInt, toNullableString, toString } = require('@/functions/transform');

/**
 * @constructor
 *
 * @param {string} action
 */
const TradingSessionEvent = function (action) {
    this.action = action;
    this.amount = 0.00;
    /**
     * Arbitrary additional data to save with the event.
     * Should be a string, so JSON encoded.
     *
     * @type {string|null}
     */
    this.data = null;
    this.denominations = null;
    this.tradingSessionID = null;
    this.floatAdjustmentReason = null;
    this.floatAdjustmentReasonID = null;
    this.ID = null;
    this.managerID = null;
    this.narrative = null;
    this.operatorID = null;

    /**
     * @type {Date}
     */
    this.triggeredAt = new Date();
};

TradingSessionEvent.prototype = {
    getHydrationMap() {
        return {
            amount: toFloat,
            action: {
                field: ['action', 'auditTypeCode'],
                transform: toString,
            },
            floatAdjustmentReason: toNullableString,
            floatAdjustmentReasonID: toNullableInt,
            ID: {
                field: ['ID', 'tradingSessionEventID'],
                transform: toString,
            },
            narrative: {
                field: ['narrative', 'text'],
                transform: toNullableString,
            },
            triggeredAt: {
                field: ['triggeredAt', 'auditEventTime'],
                transform: toDate,
            },
        };
    },

    toApiData() {
        return {
            action: this.action,
            amount: this.amount,
            data: this.data,
            denominations: this.denominations,
            tradingSessionID: this.tradingSessionID,
            floatAdjustmentReasonID: this.floatAdjustmentReasonID,
            ID: this.ID,
            managerID: this.managerID,
            narrative: this.narrative,
            operatorID: this.operatorID,
            triggeredAt: formatDateForApi(this.triggeredAt),
        };
    },

    /**
     * @param {number} operatorID
     */
    setOperatorID: function setOperatorID(operatorID) {
        this.operatorID = operatorID || null;

        return this;
    },

    /**
     * @param {float} amount
     */
    setAmount: function setAmount(amount) {
        if (typeof amount !== 'undefined') {
            this.amount = amount;
        }

        return this;
    },

    setData: function setData(data) {
        this.data = data === null ? null : JSON.stringify(data);

        return this;
    },

    /**
     * @param   {object}  denominations
     */
    setDenominations: function setDenominations(denominations) {
        this.denominations = denominations === null ? null : JSON.stringify(denominations);

        return this;
    },

    /**
     * @param {number} tradingSessionID
     */
    setTradingSessionID: function setTradingSessionID(tradingSessionID) {
        this.tradingSessionID = tradingSessionID || null;

        return this;
    },

    /**
     * @param {number} managerID
     */
    setManagerID: function setManagerID(managerID) {
        this.managerID = managerID || null;

        return this;
    },

    /**
     * @param {string} narrative
     */
    setNarrative: function setNarrative(narrative) {
        this.narrative = narrative || null;

        return this;
    },

    /**
     * @param {number|null} floatAdjustmentReasonID
     */
    setFloatAdjustmentReasonID: function setFloatAdjustmentReasonID(floatAdjustmentReasonID) {
        this.floatAdjustmentReasonID = floatAdjustmentReasonID || null;

        return this;
    },
};

module.exports = TradingSessionEvent;
